module.exports = __webpack_public_path__ + "static/media/instagramreward.9901d2fc.svg";